import React from 'react';
import ReactDOM from 'react-dom';
import { EventEmitter } from 'events';
import ConfirmModal from './ConfirmModal';

export interface ConfirmEvent {
    title: string;
    message: string;
    resolve: (confirmed: boolean) => void;
}

class ConfirmationService {
    private emitter = new EventEmitter();
    private _initialized = false;

    public init() {
        this.mountConfirmModal();
        this._initialized = true;
    }

    private mountConfirmModal() {
        const modalRoot = document.createElement('div');
        document.body.appendChild(modalRoot);
        ReactDOM.render((<ConfirmModal />), modalRoot);
    }

    public confirm(title: string, message: string): Promise<boolean> {
        if (!this._initialized) {
            throw new Error('ConfirmationService not initialized');
        }

        return new Promise((resolve) => {
            // Type assertion here to bypass the expected argument count error
            (this.emitter.emit as (event: string, payload: ConfirmEvent) => boolean)('confirm', { title, message, resolve });
        });
    }

    public onConfirm(listener: (event: ConfirmEvent) => void) {
        this.emitter.on('confirm', listener);
    }

    public offConfirm(listener: (event: ConfirmEvent) => void) {
        this.emitter.off('confirm', listener);
    }
}

export default new ConfirmationService();
